module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201707/top_images/1-7579ccf86bb310d973843d4bd6f40d58.png";